function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/tableproperties/tablepropertiesediting
 */
import { Plugin } from 'ckeditor5/src/core';
import { addBackgroundRules, addBorderRules } from 'ckeditor5/src/engine';
import TableEditing from '../tableediting';
import { downcastAttributeToStyle, downcastTableAttribute, upcastBorderStyles, upcastStyleToAttribute } from '../converters/tableproperties';
import TableBackgroundColorCommand from './commands/tablebackgroundcolorcommand';
import TableBorderColorCommand from './commands/tablebordercolorcommand';
import TableBorderStyleCommand from './commands/tableborderstylecommand';
import TableBorderWidthCommand from './commands/tableborderwidthcommand';
import TableWidthCommand from './commands/tablewidthcommand';
import TableHeightCommand from './commands/tableheightcommand';
import TableAlignmentCommand from './commands/tablealignmentcommand';
import { getNormalizedDefaultProperties } from '../utils/table-properties';
var ALIGN_VALUES_REG_EXP = /^(left|center|right)$/;
var FLOAT_VALUES_REG_EXP = /^(left|none|right)$/;
/**
 * The table properties editing feature.
 *
 * Introduces table's model attributes and their conversion:
 *
 * - border: `borderStyle`, `borderColor` and `borderWidth`
 * - background color: `backgroundColor`
 * - horizontal alignment: `alignment`
 * - width & height: `width` & `height`
 *
 * It also registers commands used to manipulate the above attributes:
 *
 * - border: `'tableBorderStyle'`, `'tableBorderColor'` and `'tableBorderWidth'` commands
 * - background color: `'tableBackgroundColor'`
 * - horizontal alignment: `'tableAlignment'`
 * - width & height: `'tableWidth'` & `'tableHeight'`
 *
 * @extends module:core/plugin~Plugin
 */

var TablePropertiesEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(TablePropertiesEditing, _Plugin);

  var _super = _createSuper(TablePropertiesEditing);

  function TablePropertiesEditing() {
    _classCallCheck(this, TablePropertiesEditing);

    return _super.apply(this, arguments);
  }

  _createClass(TablePropertiesEditing, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var editor = this.editor;
      var schema = editor.model.schema;
      var conversion = editor.conversion;
      editor.config.define('table.tableProperties.defaultProperties', {});
      var defaultTableProperties = getNormalizedDefaultProperties(editor.config.get('table.tableProperties.defaultProperties'), {
        includeAlignmentProperty: true
      });
      editor.data.addStyleProcessorRules(addBorderRules);
      enableBorderProperties(schema, conversion, {
        color: defaultTableProperties.borderColor,
        style: defaultTableProperties.borderStyle,
        width: defaultTableProperties.borderWidth
      });
      editor.commands.add('tableBorderColor', new TableBorderColorCommand(editor, defaultTableProperties.borderColor));
      editor.commands.add('tableBorderStyle', new TableBorderStyleCommand(editor, defaultTableProperties.borderStyle));
      editor.commands.add('tableBorderWidth', new TableBorderWidthCommand(editor, defaultTableProperties.borderWidth));
      enableAlignmentProperty(schema, conversion, defaultTableProperties.alignment);
      editor.commands.add('tableAlignment', new TableAlignmentCommand(editor, defaultTableProperties.alignment));
      enableTableToFigureProperty(schema, conversion, {
        modelAttribute: 'width',
        styleName: 'width',
        defaultValue: defaultTableProperties.width
      });
      editor.commands.add('tableWidth', new TableWidthCommand(editor, defaultTableProperties.width));
      enableTableToFigureProperty(schema, conversion, {
        modelAttribute: 'height',
        styleName: 'height',
        defaultValue: defaultTableProperties.height
      });
      editor.commands.add('tableHeight', new TableHeightCommand(editor, defaultTableProperties.height));
      editor.data.addStyleProcessorRules(addBackgroundRules);
      enableProperty(schema, conversion, {
        modelAttribute: 'backgroundColor',
        styleName: 'background-color',
        defaultValue: defaultTableProperties.backgroundColor
      });
      editor.commands.add('tableBackgroundColor', new TableBackgroundColorCommand(editor, defaultTableProperties.backgroundColor));
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'TablePropertiesEditing';
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "requires",
    get: function get() {
      return [TableEditing];
    }
  }]);

  return TablePropertiesEditing;
}(Plugin); // Enables `'borderStyle'`, `'borderColor'` and `'borderWidth'` attributes for table.
//
// @param {module:engine/model/schema~Schema} schema
// @param {module:engine/conversion/conversion~Conversion} conversion
// @param {Object} defaultBorder The default border values.
// @param {String} defaultBorder.color The default `borderColor` value.
// @param {String} defaultBorder.style The default `borderStyle` value.
// @param {String} defaultBorder.width The default `borderWidth` value.


export { TablePropertiesEditing as default };

function enableBorderProperties(schema, conversion, defaultBorder) {
  schema.extend('table', {
    allowAttributes: ['borderWidth', 'borderColor', 'borderStyle']
  });
  upcastBorderStyles(conversion, 'table', defaultBorder);
  downcastTableAttribute(conversion, {
    modelAttribute: 'borderColor',
    styleName: 'border-color'
  });
  downcastTableAttribute(conversion, {
    modelAttribute: 'borderStyle',
    styleName: 'border-style'
  });
  downcastTableAttribute(conversion, {
    modelAttribute: 'borderWidth',
    styleName: 'border-width'
  });
} // Enables the `'alignment'` attribute for table.
//
// @param {module:engine/model/schema~Schema} schema
// @param {module:engine/conversion/conversion~Conversion} conversion
// @param {String} defaultValue The default alignment value.


function enableAlignmentProperty(schema, conversion, defaultValue) {
  schema.extend('table', {
    allowAttributes: ['alignment']
  });
  conversion.for('downcast').attributeToAttribute({
    model: {
      name: 'table',
      key: 'alignment'
    },
    view: function view(alignment) {
      return {
        key: 'style',
        value: {
          // Model: `alignment:center` => CSS: `float:none`.
          float: alignment === 'center' ? 'none' : alignment
        }
      };
    },
    converterPriority: 'high'
  });
  conversion.for('upcast') // Support for the `float:*;` CSS definition for the table alignment.
  .attributeToAttribute({
    view: {
      name: /^(table|figure)$/,
      styles: {
        float: FLOAT_VALUES_REG_EXP
      }
    },
    model: {
      key: 'alignment',
      value: function value(viewElement) {
        var align = viewElement.getStyle('float'); // CSS: `float:none` => Model: `alignment:center`.

        if (align === 'none') {
          align = 'center';
        }

        return align === defaultValue ? null : align;
      }
    }
  }) // Support for the `align` attribute as the backward compatibility while pasting from other sources.
  .attributeToAttribute({
    view: {
      attributes: {
        align: ALIGN_VALUES_REG_EXP
      }
    },
    model: {
      name: 'table',
      key: 'alignment',
      value: function value(viewElement) {
        var align = viewElement.getAttribute('align');
        return align === defaultValue ? null : align;
      }
    }
  });
} // Enables conversion for an attribute for simple view-model mappings.
//
// @param {module:engine/model/schema~Schema} schema
// @param {module:engine/conversion/conversion~Conversion} conversion
// @param {Object} options
// @param {String} options.modelAttribute
// @param {String} options.styleName
// @param {String} options.defaultValue The default value for the specified `modelAttribute`.


function enableProperty(schema, conversion, options) {
  var modelAttribute = options.modelAttribute;
  schema.extend('table', {
    allowAttributes: [modelAttribute]
  });
  upcastStyleToAttribute(conversion, _objectSpread({
    viewElement: 'table'
  }, options));
  downcastTableAttribute(conversion, options);
} // Enables conversion for an attribute for simple view (figure) to model (table) mappings.
//
// @param {module:engine/model/schema~Schema} schema
// @param {module:engine/conversion/conversion~Conversion} conversion
// @param {Object} options
// @param {String} options.modelAttribute
// @param {String} options.styleName


function enableTableToFigureProperty(schema, conversion, options) {
  var modelAttribute = options.modelAttribute;
  schema.extend('table', {
    allowAttributes: [modelAttribute]
  });
  upcastStyleToAttribute(conversion, _objectSpread({
    viewElement: /^(table|figure)$/
  }, options));
  downcastAttributeToStyle(conversion, _objectSpread({
    modelElement: 'table'
  }, options));
}